import { Flex, Image } from '@fluentui/react-northstar';

export const LogoPanel = ({isSmall = false}) => {
    return (
        <Flex className="spacing-bottom-m" vAlign="end" hAlign="center">
            <Image src="img/beqom.svg" className={`beqom-logo ${isSmall ? 'small' : ''}`} />
        </Flex>
    );
};
